module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_8004.93332092.png";